var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompleteCheckBoxWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55819_45929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4662 25.0055C18.4475 25.0055 18.4285 25.0051 18.4094 25.0047C17.8509 24.9893 17.3242 24.751 16.9522 24.3463L11.6655 18.5909C10.9182 17.7773 10.9901 16.5282 11.8264 15.8011C12.6626 15.0732 13.9464 15.1439 14.6937 15.9576L18.5487 20.1545L31.2797 7.76796C32.0721 6.99662 33.3587 6.99662 34.1511 7.76796C34.9443 8.5397 34.9443 9.79077 34.1511 10.5621L19.9019 24.4266C19.5205 24.798 19.0039 25.0055 18.4662 25.0055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2296 35.7613C9.15222 35.7613 0.953613 27.7843 0.953613 17.9793C0.953613 8.17428 9.15222 0.197266 19.2296 0.197266C22.5725 0.197266 25.8439 1.084 28.6892 2.76222C29.6485 3.32769 29.9547 4.5424 29.374 5.47576C28.7924 6.40912 27.5439 6.70746 26.5847 6.1416C24.3737 4.83798 21.8301 4.14883 19.2296 4.14883C11.3916 4.14883 5.01494 10.3532 5.01494 17.9793C5.01494 25.6054 11.3916 31.8098 19.2296 31.8098C27.0675 31.8098 33.4442 25.6054 33.4442 17.9793C33.4442 17.3917 33.4057 16.799 33.3305 16.2177C33.1892 15.135 33.9771 14.1463 35.0899 14.0092C36.2027 13.8713 37.2184 14.6386 37.3594 15.721C37.4564 16.4666 37.5056 17.2261 37.5056 17.9793C37.5056 27.7843 29.307 35.7613 19.2296 35.7613Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55819_45929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 36,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteCheckBoxWhite);
export default __webpack_public_path__ + "static/media/completeCheckBoxWhite.4fef3ebf1084655325e566d1bfe0eda6.svg";
export { ForwardRef as ReactComponent };